import { PropTypes } from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';

import { Flex } from '../../grid';
import { Icon } from '../../icons';
import { P } from '../../typography/new';

const getStatusColor = (hasError, hasSetValue, theme = null) => {
  if (hasError) {
    return theme?.colors?.errorPrimary ?? 'errorPrimary';
  }

  return 'current-color';
};

const OrderSettingsSummaryItem = ({
  hasError,
  hasSetValue,
  iconName,
  value,
  truncateText,
  isModal,
  textVariant,
  uppercase,
}) => {
  return (
    <Flex alignItems="center" minWidth={0}>
      <Icon
        name={iconName}
        fill={getStatusColor(hasError, hasSetValue)}
        mr="4px"
        mt={{ xs: isModal ? 0 : '-2px', md: 0 }}
        width={{ xs: '24px', lg: '32px' }}
        height={{ xs: '24px', lg: '32px' }}
        minWidth={{ xs: '24px', lg: '32px' }}
      />
      <StyledActionLabel variant={textVariant} {...{ truncateText, hasError, hasSetValue, uppercase }}>
        {value}
      </StyledActionLabel>
    </Flex>
  );
};

const StyledActionLabel = styled(P)`
  color: ${({ hasError, hasSetValue, theme }) => getStatusColor(hasError, hasSetValue, theme)};
  white-space: nowrap;
  border-bottom: 1px dotted ${({ hasError, hasSetValue, theme }) => getStatusColor(hasError, hasSetValue, theme)};
  margin-bottom: 0;

  ${({ uppercase }) =>
    uppercase &&
    css`
      text-transform: uppercase;
    `}

  ${({ truncateText }) =>
    truncateText &&
    css`
      overflow: hidden;
      text-overflow: ellipsis;
    `}
`;

OrderSettingsSummaryItem.propTypes = {
  truncateText: PropTypes.bool,
  hasError: PropTypes.bool,
  hasSetValue: PropTypes.bool.isRequired,
  iconName: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  isModal: PropTypes.bool,
  textVariant: PropTypes.string,
  uppercase: PropTypes.bool,
};

OrderSettingsSummaryItem.defaultProps = {
  hasError: false,
  truncateText: false,
  isModal: false,
  textVariant: 'standard-semi-bold',
  uppercase: false,
};

export { OrderSettingsSummaryItem };
